import styled from 'styled-components';

import { MAX_APP_CONTAINER_WIDTH_NEW } from '@makemydeal/dr-shared-ui-utils';

export const ActivityRouteContainer = styled.div`
    max-width: ${MAX_APP_CONTAINER_WIDTH_NEW};
    margin: 0 auto;
    padding: 0 16px;
`;
